import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import {
  GoogleMap,
  GoogleMapsModule,
  MapAdvancedMarker,
  MapPolygon,
} from "@angular/google-maps";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { BlockUIModule } from "ng-block-ui";
import { BehaviorSubject, Observable } from "rxjs";
import { CommonComponent } from "../../../lib/components/common/common.component.mjs";
import { FiberMapDialogComponent } from "./fiber-map-dialog/fiber-map-dialog.component";
import { LayersComponent } from "./map-layers/map-layers.component";

@Component({
  selector: "app-maps",
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    GoogleMapsModule,
    MapAdvancedMarker,
    BlockUIModule,
    CommonModule,
    MatDialogModule,
    LayersComponent,
  ],
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
})
export class MapComponent
  extends CommonComponent
  implements OnInit, AfterViewInit
{
  mapDrawingLoaded = false;

  private _polygons = new BehaviorSubject<MapPolygon[]>([]);
  polygons$: Observable<MapPolygon[]> = this._polygons.asObservable();

  private _deviceStatuses = new BehaviorSubject<any[]>([]);
  deviceStatuses$: Observable<any[]> = this._deviceStatuses.asObservable();

  showGroundOverlay = false;

  minGroundOverlayZoom = 12; // Min zoom level to show the ground overlay
  maxGroundOverlayZoom = 15; // Max zoom level (exclusive) to show the ground overlay

  onZoomChanged() {
    console.log("zoom Changed")
    if (this.map) {
      const currentZoom = this.map.getZoom();
      console.log("Current zoom", currentZoom);
      if (currentZoom !== undefined) {
        this.showGroundOverlay = (currentZoom >= this.minGroundOverlayZoom && currentZoom < this.maxGroundOverlayZoom);
      }
    }
  }
  
// Array to hold data for each floor plan
floorPlans: FloorPlan[] = [
  {
    floorNumber: 1,
    name: '1st',
    url: 'http://admin.local.localhost:4200/images/SBP1A.png', // Replace with actual URL
    bounds: { south: 39.051840, west: -77.540380, north: 39.053246, east: -77.538783 }, // Replace with actual bounds
    opacity: 1.0 // Example: Slightly higher opacity for this floor
  },
  {
    floorNumber: 2,
    name: '2nd',
    url: 'http://admin.local.localhost:4200/images/SBP1A.png', // Replace with actual URL
    bounds: { south: 39.051840, west: -77.540380, north: 39.053246, east: -77.538783 }, // Replace with actual bounds
    opacity: 0.0 // Example: Slightly lower opacity for this floor
  }, 
  // Add more floors as needed
  // {
  //   floorNumber: 3,
  //   name: 'Second Floor',
  //   url: 'URL_FOR_3RD_FLOOR_IMAGE',
  //   bounds: { south: ..., west: ..., north: ..., east: ... }
  // }
];

// Property to hold the currently selected floor plan data
selectedFloor: FloorPlan | undefined;


  // Geographic bounds of the floor plan image (replace with your actual bounds)
  // These coordinates define the southwest and northeast corners of the image.
  // You will need to determine these accurately for your specific floor plan and location.
  floorPlanBounds: google.maps.LatLngBoundsLiteral = {
    south: 34.0515, // Southwest latitude
    west: -118.2445, // Southwest longitude
    north: 34.0529, // Northeast latitude
    east: -118.2429, // Northeast longitude
  };

  overlayOpacity = 0.7; // Make the overlay slightly transparent

  kmlUrl =
    "https://drive.google.com/uc?export=download&id=1LZiLeMoUyb7H1y4CsatRsZVJlyKEfcg0&live720.kml";

  options: google.maps.MapOptions = {
    mapId: "a05906154fcbd7ce",
    center: { lat: 39.081571, lng: -77.708702 },
    zoom: 13,
  };

  @ViewChild("googleMap") googleMap: GoogleMap | undefined;
  map: google.maps.Map | undefined = undefined;

  // Define the layers
  layers: { [key: string]: google.maps.Data } = {};

  constructor(private dialog: MatDialog) {
    super();
  }

  async ngOnInit() {
    this.enableMapDrawing();
  }

  handleCreateEvents(event: any) {
    this.openDialog(event.type, event.overlay);
  }

  async enableMapDrawing() {
    console.log("Checking if map ready to having drawing manager loaded");
    console.log(this.mapDrawingLoaded);
    console.log(this.map);

    if (!this.mapDrawingLoaded && this.map) {
      console.log("Ready. Loading drawing manager");

      const { DrawingManager } = (await google.maps.importLibrary(
        "drawing"
      )) as google.maps.DrawingLibrary;

      let drawingManager = new DrawingManager();

      drawingManager.addListener(
        "overlaycomplete",
        this.handleCreateEvents.bind(this)
      );
      drawingManager.setMap(this.map);
      this.mapDrawingLoaded = true;
    }
  }

  ngAfterViewInit() {
    if (
      this.googleMap &&
      this.googleMap.googleMap &&
      typeof google !== "undefined" &&
      google.maps
    ) {
      this.map = this.googleMap.googleMap;
      this.enableMapDrawing();
    }

    this.isLoading(false);
  }

  openDialog(type: string, mapData: any): void {
    let overlayData = "";

    switch (type) {
      case "polyline":
        overlayData = JSON.stringify(mapData.getPath());
        break;
      case "marker":
        overlayData = JSON.stringify(mapData.getCenter());
        break;
      case "circle":
        overlayData = JSON.stringify({
          center: mapData.getCenter(),
          radius: mapData.getRadius(),
        });
        break;
      case "polygon":
        overlayData = JSON.stringify(mapData.getPaths());
        break;
      case "rectangle":
        overlayData = JSON.stringify(mapData.getBounds());
        break;
    }

    this.dialog.open(FiberMapDialogComponent, {
      data: {
        type: type,
        mapData: overlayData,
      },
    });
  }

  getContent(deviceStatus: any) {
    const parser = new DOMParser();
    const markerRed = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#FF5733" stroke="#FFFFFF" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
    </svg>`;
    const markerGreen = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#008000" stroke="#FFFFFF" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
    </svg>`;
    const markerOrange = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#FFA500" stroke="#FFFFFF" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
    </svg>`;
    const markerBlack = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#000000" stroke="#FFFFFF" viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
    </svg>`;

    switch (deviceStatus.status) {
      case "Offline":
        return parser.parseFromString(markerRed, "image/svg+xml")
          .documentElement;
      case "Disabled":
        return parser.parseFromString(markerOrange, "image/svg+xml")
          .documentElement;
      case "Unknown":
        return parser.parseFromString(markerBlack, "image/svg+xml")
          .documentElement;
      case "Online":
        return parser.parseFromString(markerGreen, "image/svg+xml")
          .documentElement;
      // ...
      default:
        return parser.parseFromString(markerBlack, "image/svg+xml")
          .documentElement;
    }
  }

  getMarkerOptions(deviceStatus: any): MarkerOptions {
    const markerOptions: MarkerOptions = {
      title: deviceStatus.customer?.name,
    };
    return markerOptions;
  }

  getPosition(deviceStatus: any) {
    let customerPosition = {
      lat: deviceStatus.customer?.latitude ?? 0,
      lng: deviceStatus.customer?.longitude ?? 0,
    };
    return customerPosition;
  }

  toggleLayer(event: {
    key: string;
    enabled: boolean;
    layer: google.maps.Data;
  }) {
    // Check if the layer exists; if not, create it
    if (!this.layers[event.key]) {
      this.layers[event.key] = event.layer;
    }

    const dataLayer = this.layers[event.key];

    if (!event.enabled) {
      dataLayer.setMap(null); // Remove layer
      console.log(`${event.layer} layer removed`);
    } else {
      // Attach event listener to the feature
      google.maps.event.addListener(dataLayer, "click", (event: any) => {
        const properties = event.feature.Fg; // Get all properties
        let content = "<div>";
        for (const key in properties) {
          if (properties.hasOwnProperty(key)) {
            const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
            content += `<strong>${formattedKey}:</strong> ${properties[key]}<br>`;
          }
        }
        content += "</div>";
        const infoWindow = new google.maps.InfoWindow({
          content,
          position: event.feature.getGeometry().get(),
        });

        infoWindow.open(this.map);
      });
      dataLayer.setMap(this.map ?? null); // Show layer
      console.log(`${event.layer} layer added`);
    }
  }

    /**
   * Selects a floor plan to display on the map.
   * @param floorNumber The number of the floor to select.
   */
    selectFloor(floorNumber: number): void {
      const floor = this.floorPlans.find(f => f.floorNumber === floorNumber);
      if (floor) {
        this.selectedFloor = floor;
        // Optionally adjust map center or zoom when switching floors
        // this.center = { lat: (floor.bounds.south + floor.bounds.north) / 2, lng: (floor.bounds.west + floor.bounds.east) / 2 };
        // this.zoom = 19;
      } else {
        console.warn(`Floor ${floorNumber} not found.`);
        this.selectedFloor = undefined; // Deselect if floor not found
      }
    }
}

interface MarkerOptions {
  position?: google.maps.LatLng;
  title?: string;
  icon?: MarkerOptionsIcon;
  // ... other properties
}

interface MarkerOptionsIcon {
  url: string;
  scaledSize?: google.maps.Size;
}

export interface DialogData {
  type: string;
  mapData: any;
}


// Define an interface for floor plan data
interface FloorPlan {
  floorNumber: number;
  name: string; // Optional: A friendly name for the floor
  url: string;
  bounds: google.maps.LatLngBoundsLiteral;
  opacity?: number; // Optional: Allow specific opacity per floor
}